// extracted by mini-css-extract-plugin
export default {"itemCont":"ItemsScreen_itemCont__4Xfqv","cateCont":"ItemsScreen_cateCont__O1z9W","container":"ItemsScreen_container__2FqMD"};